<h4>Une autre date de rendez-vous a-t-elle été positionnée ?</h4>
<div class="dialog-buttons">
  <button mat-button (click)="onNoClick()">Non</button>
  <button mat-button (click)="onYesClick()">Oui</button>
</div>

<div *ngIf="showDatePicker">
  <mat-form-field appearance="fill">
    <mat-label>Nouvelle date</mat-label>
    <input matInput [matDatepicker]="picker" formControlName="rdv_repositionne"
      (dateChange)="onDateSelected($event)">
    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
    <mat-datepicker #picker></mat-datepicker>
  </mat-form-field>
</div>

<div *ngIf="showValidateButton">
  <button mat-button color="primary" (click)="saveNewRdv()">Valider</button>
</div>
